import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=8df76af0&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
import style0 from "./Account.vue?vue&type=style&index=0&id=8df76af0&prod&scoped=true&lang=scss"
import style1 from "./Account.vue?vue&type=style&index=1&id=8df76af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df76af0",
  null
  
)

export default component.exports